import React from 'react';

import { MODIFY_NOTE, GET_NOTE } from '../../../common/graphql/note';
import NoteDetail from './NoteDetail';

const NoteDetailView = props => {
	const { data } = props;
	return (
		<NoteDetail
			{...props}
			id={data.id}
			query={GET_NOTE}
			modifyMutation={MODIFY_NOTE}
		/>
	);
};

export default NoteDetailView;
